// Resolves the CalendarConfig (provider + eventTypeId) the API-driven booking widget
// (CalendlyCustomWidget) sends to the backend for a given appointmentType. Dev vs prod is decided
// here, the same way the older iframe widget already does it (see
// hooks/useAppointmentBookingCalendar.ts) - REACT_APP_ENV picks between a plain env var and its
// _DEV counterpart. The backend holds no calendar config of its own; it only has Calendly account
// credentials, and fetches the event type directly by this ID - no search/lookup call.
export interface CalendarConfig {
  provider: "calendly";
  eventTypeId: string;
}

const isDev = process.env.REACT_APP_ENV === "dev";

const resolve = (prodId?: string, devId?: string): string => {
  const preferred = isDev ? devId : prodId;
  return preferred || "";
};

const CALENDAR_EVENT_TYPE_IDS: Record<string, string> = {
  "portal-general-appointment": resolve(
    process.env.REACT_APP_CALENDLY_EVENT_TYPE_ID_PORTAL_GENERAL_APPOINTMENT,
    process.env.REACT_APP_CALENDLY_EVENT_TYPE_ID_PORTAL_GENERAL_APPOINTMENT_DEV
  ),
  "portal-drawdown-appointment": resolve(
    process.env.REACT_APP_CALENDLY_EVENT_TYPE_ID_PORTAL_DRAWDOWN_APPOINTMENT,
    process.env.REACT_APP_CALENDLY_EVENT_TYPE_ID_PORTAL_DRAWDOWN_APPOINTMENT_DEV
  ),
};

export function getCalendarConfig(appointmentType: string): CalendarConfig {
  return {
    provider: "calendly",
    eventTypeId: CALENDAR_EVENT_TYPE_IDS[appointmentType] ?? "",
  };
}
